"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConfiguration = exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Default configuration structure
var currentConfiguration = {
  styles: {
    namespace: null
  }
};

var updateConfiguration = function updateConfiguration(newValues) {
  currentConfiguration = _objectSpread(_objectSpread({}, currentConfiguration), newValues);
}; // Add a way to set the configuration without a knowledge of this package.
// We need this, because sometimes we don't have access to the actual wel
// context.


exports.updateConfiguration = updateConfiguration;

if (global.emcmUiConfig) {
  updateConfiguration(global.emcmUiConfig);
}

var _default = {
  get current() {
    return currentConfiguration;
  }

};
exports["default"] = _default;